(function () {
  var STAMPED_ENDPOINT = 'https://stamped.io/api/widget/reviews';

  function buildStars(rating) {
    var wrap = document.createElement('div');
    wrap.className = 'content-customer-reviews__stars';
    var rounded = Math.round(rating || 0);

    for (var i = 1; i <= 5; i++) {
      var star = document.createElement('span');
      star.className = 'content-customer-reviews__star' + (i <= rounded ? ' is-filled' : '');
      star.textContent = '★';
      wrap.appendChild(star);
    }

    return wrap;
  }

  function buildCard(review) {
    // Slick adds its own classes (slick-slide, slick-center, ...) directly
    // onto whichever element we hand it — it does not insert a wrapper.
    // We keep that element (`slide`) purely structural and put all visual
    // styling (padding/scale/shadow) on a separate inner `card` element,
    // so Slick's own layout rules never collide with ours.
    var slide = document.createElement('div');
    slide.className = 'content-customer-reviews__slide';

    var card = document.createElement('div');
    card.className = 'content-customer-reviews__card';
    slide.appendChild(card);

    card.appendChild(buildStars(review.reviewRating));

    if (review.reviewTitle) {
      var title = document.createElement('h3');
      title.className = 'content-customer-reviews__title';
      title.textContent = review.reviewTitle;
      card.appendChild(title);
    }

    if (review.reviewMessage) {
      var message = document.createElement('p');
      message.className = 'content-customer-reviews__message';
      message.textContent = review.reviewMessage;
      card.appendChild(message);
    }

    var meta = document.createElement('div');
    meta.className = 'content-customer-reviews__meta';

    var imageUrl = review.productImageUrl || review.productImageThumbnailUrl;
    if (imageUrl) {
      var image = document.createElement('img');
      image.className = 'content-customer-reviews__product-image';
      image.src = imageUrl;
      image.alt = review.productName || '';
      image.loading = 'lazy';
      meta.appendChild(image);
    }

    var author = document.createElement('p');
    author.className = 'content-customer-reviews__author';
    author.textContent = review.author || 'Anonymous';
    meta.appendChild(author);

    if (review.productName) {
      var product = document.createElement('p');
      product.className = 'content-customer-reviews__product';
      product.textContent = review.productName + ' をご購入';
      meta.appendChild(product);
    }

    card.appendChild(meta);

    return slide;
  }

  function fetchProductReviews(root, productId) {
    var params = new URLSearchParams({
      apiKey: root.dataset.apiKey,
      sId: root.dataset.storeHash,
      productId: productId,
      minRating: root.dataset.minRating || '1',
      reviewsPerPage: root.dataset.reviewsPerProduct || '3',
      page: '1',
      isWithPhotos: 'false',
    });

    return fetch(STAMPED_ENDPOINT + '?' + params.toString())
      .then(function (response) {
        return response.ok ? response.json() : { data: [] };
      })
      .then(function (json) {
        return Array.isArray(json.data) ? json.data : [];
      })
      .catch(function () {
        return [];
      });
  }

  function markCurrentSlide($slider, currentSlide) {
    $slider.find('.slick-slide').removeClass('is-current');
    $slider
      .find('.slick-slide[data-slick-index="' + currentSlide + '"]')
      .addClass('is-current');
  }

  function initSlider(track, autoplaySpeed) {
    if (!window.jQuery || !window.jQuery.fn.slick) return;

    var $track = window.jQuery(track);

    $track.on('init', function (event, slick) {
      markCurrentSlide($track, slick.currentSlide);
    });

    // Mark the upcoming center slide in `beforeChange` (fires as the slide
    // move starts) rather than `afterChange` (fires once it's done) — that
    // way the scale/shrink transition runs *during* the horizontal slide
    // animation instead of kicking in only after it finishes.
    $track.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      markCurrentSlide($track, nextSlide);
    });

    $track.slick({
      slidesToShow: 3,
      centerMode: true,
      centerPadding: '0',
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: autoplaySpeed,
      infinite: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // 'init' should already have marked the current slide, but some Slick
    // versions fire it before the DOM settles — mark it again to be safe.
    markCurrentSlide($track, $track.slick('slickCurrentSlide'));
  }

  function initReviews(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var productIds = (root.dataset.productIds || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);

    var loading = root.querySelector('.content-customer-reviews__loading');
    var track = root.querySelector('.content-customer-reviews__track');

    if (!productIds.length) {
      root.hidden = true;
      return;
    }

    Promise.all(
      productIds.map(function (id) {
        return fetchProductReviews(root, id);
      })
    )
      .then(function (results) {
        var reviews = results.reduce(function (acc, list) {
          return acc.concat(list);
        }, []);

        reviews = reviews.filter(function (review) {
          return review.reviewTitle || review.reviewMessage;
        });

        var seen = {};
        reviews = reviews.filter(function (review) {
          if (seen[review.id]) return false;
          seen[review.id] = true;
          return true;
        });

        reviews.sort(function (a, b) {
          return new Date(b.dateCreated) - new Date(a.dateCreated);
        });

        var limit = parseInt(root.dataset.reviewsToShow, 10) || 9;
        reviews = reviews.slice(0, limit);

        if (!reviews.length) {
          root.hidden = true;
          return;
        }

        reviews.forEach(function (review) {
          track.appendChild(buildCard(review));
        });

        if (loading) loading.hidden = true;
        track.hidden = false;

        initSlider(track, parseInt(root.dataset.autoplaySpeed, 10) || 4000);
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('[data-content-customer-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-content-customer-reviews]');
    if (root) initReviews(root);
  });
})();
